<template>
  <el-menu class="navbar" mode="horizontal">
    <div class="navbar-left">
      <hamburger class="hamburger-container"></hamburger>
      <div class="title">
        <span class="din-regular">{{ $t('login.title') }}</span>
      </div>
      <div v-if="$store.getters.roles.includes('DEV')" style="line-height: 45px; height: 50px; float: left; padding: 0 15px;">
        <el-switch :value="devMode"
                   active-text="dev mode"
                   @change="setDevMode"
        />
      </div>
    </div>
    <div class="navbar-center">
      <div class="title page-name">
        <span class="din-regular">{{ title }}</span>
      </div>
    </div>
    <div class="navbar-right">
      <div class="right-menu">

        <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
          <div class="avatar-wrapper">
            <!--<img :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar">-->
            <div class="user-info">
              <span class="user-name">{{ name }}</span>
              <span v-if="cOrganizationName" class="user-name">{{ cOrganizationName }}</span>
              <span v-else class="user-name no-organization">{{ $t('login.organization-not-set') }}</span>
            </div>
            <svg-icon icon-class="userCircle"/>
            <i class="el-icon-caret-bottom" />
          </div>
          <el-dropdown-menu slot="dropdown">
            <router-link v-if="false" to="/">
              <el-dropdown-item>
                {{ $t('navbar.dashboard') }}
              </el-dropdown-item>
            </router-link>

            <!--<el-dropdown-item divided>-->
            <el-dropdown-item>
              <span style="display:block;" @click="logout">{{ $t('navbar.logOut') }}</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <el-tooltip v-if="selectLanguageAvailable" effect="dark" :content="$t('navbar.language')" placement="left">
          <div class="international right-menu-item">
            <lang-select></lang-select>
            {{language}}
          </div>
        </el-tooltip>

      </div>
    </div>

  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Hamburger from '@/components/layout/Hamburger'
import LangSelect from '@/components/layout/LangSelect'
import { getOrganizations } from '@/utils/mvzsppUtil'
import genericPages from '@/router/genericPages'

export default {
  components: {
    Hamburger,
    LangSelect
  },
  data () {
    return {
      currentLang: '',
      langList: [{
        flag: 'ru',
        value: 'ru'
      }, {
        flag: 'gb',
        value: 'en'
      }],
      // openedsidebar: true
      selectLanguageAvailable: false,
      title: ''
    }
  },
  watch: {
    devMode: {
      handler: function (devMode) {

      },
      immediate: true
    },
    $route(to) {
      const routePath = to.matched[0].path
      const page = genericPages.find(gPage => (gPage.path === routePath || gPage.path === '/' + routePath))
      this.title = this.$t(page.settings.title)
      if (page.redirect) {
        this.title += ' / ' + this.$t(page.children.find(child => child.path === to.path).settings.title)
      }
    }
  },
  created: function () {
    this.currentLang = this.$store.getters.language
    this.selectLanguageAvailable = (this.$store.getters.getAvailableLanguages || []).length > 1
    const routePath = this.$router.history.current.matched[0].path
    const page = genericPages.find(gPage => (gPage.path === routePath || gPage.path === '/' + routePath))
    this.title = this.$t(page.settings.title)
    if (page.redirect) {
      this.title += ' / ' + this.$t(page.children.find(child => child.path === this.$route.path).settings.title)
    }
  },
  computed: {
    ...mapGetters([
      // 'sidebar',
      'name',
      'devMode',
      // 'avatar'
    ]),
    cOrganizationName () {
      const organizationId = this.$store.getters.user.organizationId
      return organizationId ? getOrganizations().find(o => o.id === organizationId).name : null
      // organization-not-set
    },
    // openedsidebar2 () {
    //   // let o = JSON.parse(JSON.stringify(this.$store.getters.getSidebar))
    //   // let opened = o.opened
    //   let opened = true
    //   console.log(opened)
    //   return opened
    // }
    language () {
      return this.$store.getters.getLanguage
    }
  },
  methods: {
    setDevMode (devMode) {
      this.$store.dispatch('setDevMode', devMode)
    },
    handleSetLanguage (lang) {
      this.debug && console.log(lang)
      if (lang !== this.$i18n.locale) {
        this.$i18n.locale = lang
        this.$store.dispatch('setLanguage', {lang: lang})
      }
    },
    toggleSideBar () {
      console.log('=== toggleSideBar ===')
      this.$store.dispatch('toggleSideBar')
    },
    async logout () {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login`)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .none {
    display: none;
  }
img.logo {
  height: 22px;
  margin: 13px 10px;
}
.title {
  float: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  font-size: 1.3rem;
}
.title.page-name {
  font-weight: bold;
}
.navbar:before, .navbar:after {
  display: none;
}
.navbar {
  z-index: 999;
  height: 50px;
  /*line-height: 50px;*/
  border-radius: 0px !important;
  position: fixed;
  width: 100%;
  background: #fff;
  top: 0;
  box-shadow: 0px 2px 0px 0 rgba(0,0,0,.02), 0 0 3px 0 rgba(0,0,0,.04);
  border-bottom: 1px solid #ccc;
  display: flex;
  justify-content: space-between;

  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 15px;
  }
  .breadcrumb-container{
    float: left;
  }
  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }
  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus{
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      margin: 0 8px;

      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }
    .screenfull {
      height: 20px;
    }
    .international{
      /*vertical-align: top;*/
    }
    .theme-switch {
      vertical-align: 15px;
    }

    .avatar-container {
      /*height: 50px;*/
      margin-right: 30px;

      .avatar-wrapper {
        /*margin-top: 5px;*/
        position: relative;
        display: flex;

        .user-info {
          display: flex;
          flex-direction: column;
          text-align: right;
        }

        .user-name {
          display: inline-block;
          margin: 0 8px;
          padding: 0 8px;
          font-size: 13px;
          color: #5a5e66;
          line-height: 23px;
        }

        .no-organization {
          font-style: italic;
          color: #99a9bf;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          font-size: 12px;
          margin: auto 0;
        }

        .svg-icon {
          margin: auto 5px;
        }
      }
    }
  }
  .selection.dropdown {
    min-width: 63px;
    max-width: 63px;
    margin: 0 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue